import mockUsers from './mock_users';

let users = [...mockUsers];

console.log('users: ', users);

const fakeDatabase = {
  users,
};

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const loginResponse = async ({email, password}) => {
  console.log('#loginResponse, email: %s, password: %s', email, password);

  return await delay(500).then(() => {
    let res = {};
    if (email === 'jamesb@school.edu') {
      console.log('login successful');
      res = {
        status: 'ok',
        statusCode: 200,
        data: {
          token: fakeDatabase.users[0].token,
          user: fakeDatabase.users[0].user,
        }
      };
    } else {
      console.log('no jamesb@school.edu found');
      res = {
        status: 'failed login',
        statusCode: 404,
        error: 'failed login'
      };
    }

    return res;
  });
};

export const signUpResponse = async ({firstName, lastName, gradMonthYear, email, password}) => {
  console.log('API#signupResponse, start');
  console.log(
    `firstName: ${firstName}, lastName: ${lastName}, gradMonthYear: ${gradMonthYear}, email: ${email}, password: ${password}`
  );

  const userInfo = fakeDatabase.users[0];
  return await delay(500).then(() => {
    let res = {
      status: 'created',
      statusCode: 201,
      data: {
        user: userInfo.user,
        token: userInfo.token
      }
    };
    console.log('API#signupResponse, done, res: ', res);
    return res;
  });
};

export const okResponse = () =>
  delay(500).then(() => {
    console.log('okResponse');
    return JSON.stringify({
      status: 'ok',
      statusCode: 200,
    });
  });
